export const mainLandingRoutes = [
  { path: '/resident', audience: 'resident', label: 'Resident' },
  { path: '/commercial', audience: 'commercial', label: 'Commercial' },
  { path: '/tenders/government', audience: 'government', label: 'Government Tenders' },
  { path: '/tenders/private', audience: 'private', label: 'Private Tenders' },
];

/** The main menu in the site header. */
export const primaryNavigation = [
  { label: 'For your home', href: '/resident' },
  { label: 'For suppliers', href: '/commercial' },
  { label: 'Tenders', href: '/tenders/government', also: ['/tenders'] },
  { label: 'For housing teams', href: '/housing-provider/repairs' },
  { label: 'Home services', href: '/home-services' },
];

/** The links in the site footer. */
export const footerNavigation = [
  { label: 'Your home', href: '/resident' },
  { label: 'Home jobs', href: '/home/jobs' },
  { label: 'Home services', href: '/home-services' },
  { label: 'Support', href: '/support' },
  { label: 'Privacy', href: '/privacy' },
  { label: 'Terms', href: '/terms' },
];

/** The trades on the home services page. Each one opens the home job form with its category filled in. */
export const homeServiceCategories = [
  { label: 'Plumbing', description: 'Help with taps, pipes and bathroom fittings.' },
  { label: 'Electrical', description: 'Help with lights, sockets and electrical work.' },
  { label: 'Painting & decorating', description: 'Refresh rooms, walls and finishes.' },
  { label: 'Carpentry', description: 'Help with doors, shelving and fittings.' },
  { label: 'Cleaning', description: 'Help with cleaning around your home.' },
  { label: 'General home repairs', description: 'Describe the job you need help with.' },
];

export const homeJobPath = (category) => (category ? `/home/jobs?category=${encodeURIComponent(category)}` : '/home/jobs');
